import React, { useState, useEffect } from 'react'
import { MEDIUM } from '../constants'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import 'katex/dist/katex.min.css'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'
import { FloatingSubmit } from '../UIUtilsFiles/FloatingSubmit'

function NumberPickerComponent({
  mcData,
  isPractice,
  completed,
  isActive,
  onValueChange,
  onAttemptChange,
  defaultValue,
  explanationClick,
  onExplanationVisible,
  isVerifyMode,
  timerEnd,
  isEmbeded,
  followTheFlow,
  currentPriority,
  onPriorityChange,
  sequenceMessage,
  handleSucAndFailFeedback,
  onDisplayDoneClick,
  isResetClick
}) {
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Type,
    MinRange,
    MaxRange,
    Answers,
    Score,
    Background,
    AnswerColorFill,
    Description,
    QuestionColorFill,
    AnswerFontSize,
    QuestionFontSize,
    Opacity,
    AnswerFillColor,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    SequenceHint
  } = mcData

  const [validate, setValidate] = useState(false)
  const [pickerValueArray, setPickerValueArray] = useState([])
  const [symbolValue, setSymbolValue] = useState('+')
  const [initial, setInitial] = useState(true)
  const [isSymbolSelected, setIsSymbolSelected] = useState(false)
  const [valueSelectedIndex, setValueSelectedIndex] = useState(-1)
  const [displayDone, setDisplayDone] = useState(false)
  const [onBlurCall, setOnBlurCall] = useState(true)

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlValue) {
          if (
            defaultValue.CtlValue.pickerValueArray &&
            defaultValue.CtlValue.selectedSymbol
          ) {
            let defaultValueSelected = defaultValue.CtlValue.pickerValueArray
            let defaultSelectedSymbol = defaultValue.CtlValue.selectedSymbol
            setPickerValueArray(defaultValueSelected)
            setSymbolValue(defaultSelectedSymbol)
          } else {
            initialValue()
          }
        } else {
          initialValue()
        }
      } else {
        initialValue()
      }
      setOnBlurCall(false)
    }
  }, [defaultValue, onBlurCall])
  useEffect(() => {
    if (isResetClick) {
      setOnBlurCall(true)
    }
  }, [isResetClick])

  function initialValue() {
    let numberOfDigits = 0
    let valueArray = []
    let checkSlideAttendCopy = []
    if (Type === 'exactMatch') {
      let answerValue = Answers.toString()
      if (answerValue.includes('-')) {
        answerValue = answerValue.replace('-', '')
      }
      numberOfDigits = answerValue.length
    } else {
      let answerMinValue = MinRange.toString()
      let answerMaxValue = MaxRange.toString()
      if (answerMinValue.includes('-')) {
        answerMinValue = answerMinValue.replace('-', '')
      }
      if (answerMaxValue.includes('-')) {
        answerMaxValue = answerMaxValue.replace('-', '')
      }
      if (answerMaxValue.length >= answerMinValue.length) {
        numberOfDigits = answerMaxValue.length
      } else {
        numberOfDigits = answerMinValue.length
      }
    }
    for (let i = 0; i < numberOfDigits; i++) {
      valueArray[i] = 0
      checkSlideAttendCopy[i] = 0
    }
    setPickerValueArray(valueArray)
    setSymbolValue('+')
  }

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, pickerValueArray, symbolValue)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let selectedNumberString = pickerValueArray.toString()
    selectedNumberString = selectedNumberString.replace(/,/g, '')
    if (symbolValue === '-') {
      selectedNumberString = '-' + selectedNumberString
    }
    let finalValue = parseInt(selectedNumberString)
    if (Type === 'exactMatch') {
      if (finalValue === Answers) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    } else if (Type === 'range') {
      if (finalValue >= MinRange && finalValue <= MaxRange) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }

  useEffect(() => {
    if (pickerValueArray.length > 0) {
      let selectedNumberString = pickerValueArray.toString()
      selectedNumberString = selectedNumberString.replace(/,/g, '')
      if (symbolValue === '-') {
        selectedNumberString = '-' + selectedNumberString
      }
      let finalValue = parseInt(selectedNumberString)
      if (Type === 'exactMatch') {
        if (finalValue === Answers) {
          setValidate(true)
        } else {
          setValidate(false)
        }
      } else if (Type === 'range') {
        if (finalValue >= MinRange && finalValue <= MaxRange) {
          setValidate(true)
        } else {
          setValidate(false)
        }
      }
    }
  }, [pickerValueArray, symbolValue])

  useEffect(() => {
    if (onDisplayDoneClick) {
      if (displayDone) {
        onDisplayDoneClick({ id: ControlID, displayDone: displayDone })
      } else {
        onDisplayDoneClick({ id: undefined, displayDone: displayDone })
      }
    }
  }, [displayDone])

  //Hide tick icon when activity is completed
  useEffect(() => {
    if (completed === 1 || !isActive) {
      setDisplayDone(false)
    }
  }, [completed, isActive])

  function incrementValue(indexValue) {
    setValueSelectedIndex(indexValue)
    setInitial(false)
    let pickerValueArrayCopy = [...pickerValueArray]
    pickerValueArrayCopy[indexValue] = pickerValueArrayCopy[indexValue] + 1
    setPickerValueArray(pickerValueArrayCopy)
    if (isEmbeded) {
      setDisplayDone(true)
    } else {
      onAttemptChange(1)
      validateCorrectAnswer(false, pickerValueArrayCopy, symbolValue)
      setInitial(true)
    }
  }

  function decrementValue(indexValue) {
    setValueSelectedIndex(indexValue)
    setInitial(false)
    let pickerValueArrayCopy = [...pickerValueArray]
    pickerValueArrayCopy[indexValue] = pickerValueArrayCopy[indexValue] - 1
    setPickerValueArray(pickerValueArrayCopy)
    if (isEmbeded) {
      setDisplayDone(true)
    } else {
      onAttemptChange(1)
      validateCorrectAnswer(false, pickerValueArrayCopy, symbolValue)
      setInitial(true)
    }
  }

  //validate answer to check answered correctly
  function validateAnswer() {
    let isCorrect = false
    let selectedNumberString = pickerValueArray.toString()
    selectedNumberString = selectedNumberString.replace(/,/g, '')
    if (symbolValue === '-') {
      selectedNumberString = '-' + selectedNumberString
    }
    let finalValue = parseInt(selectedNumberString)
    if (Type === 'exactMatch') {
      if (finalValue === Answers) {
        isCorrect = true
      }
    } else if (Type === 'range') {
      if (finalValue >= MinRange && finalValue <= MaxRange) {
        isCorrect = true
      }
    }
    return isCorrect
  }

  function validateCorrectAnswer(
    timerValue,
    pickerValueArrayCopy,
    selectedSymbolCopy
  ) {
    let selectedNumberString = pickerValueArrayCopy.toString()
    selectedNumberString = selectedNumberString.replace(/,/g, '')
    if (selectedSymbolCopy === '-') {
      selectedNumberString = '-' + selectedNumberString
    }
    let finalValue = parseInt(selectedNumberString)
    const workedJson = {
      pickerValueArray: pickerValueArrayCopy,
      selectedSymbol: selectedSymbolCopy
    }
    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (Type === 'exactMatch') {
          if (finalValue === Answers) {
            onPriorityChange(Priority)
          }
        } else if (Type === 'range') {
          if (finalValue >= MinRange && finalValue <= MaxRange) {
            onPriorityChange(Priority)
          }
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (Type === 'exactMatch') {
      if (finalValue === Answers) {
        onValueChange(ControlID, workedJson, Score, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        onValueChange(ControlID, workedJson, 0, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    } else if (Type === 'range') {
      if (finalValue >= MinRange && finalValue <= MaxRange) {
        onValueChange(ControlID, workedJson, Score, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        onValueChange(ControlID, workedJson, 0, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    }
  }

  useEffect(() => {
    if (isSymbolSelected) {
      setTimeout(() => {
        setIsSymbolSelected(false)
      }, 1000)
    }
    if (valueSelectedIndex > -1) {
      setTimeout(() => {
        setValueSelectedIndex(-1)
      }, 1000)
    }
  }, [isSymbolSelected, valueSelectedIndex])

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
      style={{
        height: isEmbeded ? 'fit-content' : '100%',
        display: 'flex',
        padding: '5px'
      }}
    >
      {isEmbeded && displayDone && (
        <FloatingSubmit
          submitClicked={() => {
            onAttemptChange(1)
            validateCorrectAnswer(false, pickerValueArray, symbolValue)
            setOnBlurCall(true)
            setDisplayDone(false)
            setInitial(true)
          }}
        />
      )}
      <div className='number-picker-main'>
        <div className='number-cont'>
          <div
            className='num-arrow-cont'
            style={{ backgroundColor: AnswerFillColor }}
            onClick={() => {
              if (isPractice && followTheFlow && isEmbeded) {
                let isCorrect = validateAnswer()
                if (isCorrect) {
                } else {
                  if (completed === 0 && isActive) {
                    setIsSymbolSelected(true)
                    setSymbolValue('+')
                    setInitial(false)
                    setDisplayDone(true)
                  }
                }
              } else {
                if (completed === 0 && isActive) {
                  setIsSymbolSelected(true)
                  setSymbolValue('+')
                  onAttemptChange(1)
                  validateCorrectAnswer(false, pickerValueArray, '+')
                  setInitial(true)
                }
              }
            }}
          >
            <ArrowDropUpIcon
              style={{ width: '20px', height: '20px', color: AnswerColorFill }}
            />
          </div>
          <div
            className='num-cont'
            style={{
              backgroundColor: isSymbolSelected
                ? '#FFC42D'
                : isPractice || completed === 1 || !isActive
                ? initial
                  ? validate
                    ? '#3EC986'
                    : '#ff551f'
                  : AnswerFillColor
                : AnswerFillColor
            }}
          >
            <p
              className='numb-label'
              style={{
                color: isSymbolSelected
                  ? '#000000'
                  : isPractice || completed === 1 || !isActive
                  ? initial
                    ? '#ffffff'
                    : AnswerColorFill
                  : AnswerColorFill
              }}
            >
              {symbolValue && symbolValue === '+' ? '+' : '-'}
            </p>
          </div>
          <div
            className='num-arrow-cont'
            style={{ backgroundColor: AnswerFillColor }}
            onClick={() => {
              if (isPractice && followTheFlow && isEmbeded) {
                let isCorrect = validateAnswer()
                if (isCorrect && currentPriority > Priority) {
                } else {
                  if (completed === 0 && isActive) {
                    setIsSymbolSelected(true)
                    setSymbolValue('-')
                    setInitial(false)
                    setDisplayDone(true)
                  }
                }
              } else {
                if (completed === 0 && isActive) {
                  setIsSymbolSelected(true)
                  setSymbolValue('-')
                  onAttemptChange(1)
                  validateCorrectAnswer(false, pickerValueArray, '-')
                  setInitial(true)
                }
              }
            }}
          >
            <ArrowDropDownIcon
              style={{ width: '20px', height: '20px', color: AnswerColorFill }}
            />
          </div>
        </div>
        {pickerValueArray &&
          pickerValueArray.map((item, index) => {
            return (
              <div className='number-cont' key={index.toString() + 'num1'}>
                <div
                  className='num-arrow-cont'
                  style={{ backgroundColor: AnswerFillColor }}
                  onClick={() => {
                    if (isPractice && followTheFlow && isEmbeded) {
                      let isCorrect = validateAnswer()
                      if (isCorrect && currentPriority > Priority) {
                      } else {
                        if (completed === 0 && isActive) {
                          if (item !== 9) {
                            incrementValue(index)
                          }
                        }
                      }
                    } else {
                      if (completed === 0 && isActive) {
                        if (item !== 9) {
                          incrementValue(index)
                        }
                      }
                    }
                  }}
                >
                  <ArrowDropUpIcon
                    style={{
                      width: '20px',
                      height: '20px',
                      color: AnswerColorFill
                    }}
                  />
                </div>
                <div
                  className='num-cont'
                  style={{
                    backgroundColor:
                      valueSelectedIndex === index
                        ? '#FFC42D'
                        : isPractice || completed === 1 || !isActive
                        ? initial
                          ? validate
                            ? '#3EC986'
                            : '#ff551f'
                          : AnswerFillColor
                        : AnswerFillColor
                  }}
                >
                  <p
                    className='numb-label'
                    style={{
                      color:
                        valueSelectedIndex === index
                          ? '#000000'
                          : isPractice || completed === 1 || !isActive
                          ? initial
                            ? '#ffffff'
                            : AnswerColorFill
                          : AnswerColorFill
                    }}
                  >
                    {item}
                  </p>
                </div>
                <div
                  className='num-arrow-cont'
                  style={{ backgroundColor: AnswerFillColor }}
                  onClick={() => {
                    if (isPractice && followTheFlow && isEmbeded) {
                      let isCorrect = validateAnswer()
                      if (isCorrect && currentPriority > Priority) {
                      } else {
                        if (completed === 0 && isActive) {
                          if (item !== 0) {
                            decrementValue(index)
                          }
                        }
                      }
                    } else {
                      if (completed === 0 && isActive) {
                        if (item !== 0) {
                          decrementValue(index)
                        }
                      }
                    }
                  }}
                >
                  <ArrowDropDownIcon
                    style={{
                      width: '20px',
                      height: '20px',
                      color: AnswerColorFill
                    }}
                  />
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default NumberPickerComponent
